import React, { useEffect, useState } from 'react';
import {
  FiFileText,
  FiClock,
  FiAward,
  FiCheckCircle,
  FiArrowRight,
  FiUserPlus
} from 'react-icons/fi';
import { db } from '../services/api';

const KPI_ICONS = {
  allocated: { icon: FiFileText, tone: 'primary' },
  requests: { icon: FiClock, tone: 'blue' },
  certificates: { icon: FiAward, tone: 'green' },
  account: { icon: FiCheckCircle, tone: 'amber' }
};

export default function PartnerDashboard({ session, go }) {
  const [stats, setStats] = useState({ allocated: 0, requests: 0, certificates: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const [allocations, requests, certificates] = await Promise.all([
        db.allocations.list(),
        db.requests.mine(session.partnerId),
        db.certificates.mine(session.partnerId)
      ]);

      setStats({
        allocated: (allocations.data || []).filter(row => row.partner_id === session.partnerId && row.status === 'active').length,
        requests: (requests.data || []).length,
        certificates: (certificates.data || []).length
      });
      setLoading(false);
    };

    load();
  }, [session.partnerId]);

  const kpis = [
    { key: 'allocated', label: 'Allocated Content', value: stats.allocated, route: 'content', hint: 'Available to you' },
    { key: 'requests', label: 'Requests', value: stats.requests, route: 'requests', hint: 'Total submitted' },
    { key: 'certificates', label: 'Certificates', value: stats.certificates, route: 'certificates', hint: 'Issued till date' },
    { key: 'account', label: 'Account', value: 'Active', route: 'content', hint: 'Partner status' }
  ];

  return (
    <div>
      <div className="hero">
        <div>
          <span className="tag">PARTNER PORTAL</span>
          <h2>Welcome, {session.name}</h2>
          <p>Everything allocated to your organisation in one place.</p>
        </div>
        <button className="primary" onClick={() => go('register')} type="button">
          <FiUserPlus size={13} style={{ marginRight: 6, verticalAlign: -2 }} />
          Register Student
        </button>
      </div>

      <div className="kpi-grid">
        {kpis.map(({ key, label, value, route, hint }) => {
          const { icon: Icon, tone } = KPI_ICONS[key];
          return (
            <div className={`kpi-card tone-${tone}`} key={key}>
              <div className="kpi-card-top">
                <div className="kpi-icon">
                  <Icon size={18} />
                </div>
                <button className="kpi-link" onClick={() => go(route)} type="button">
                  View <FiArrowRight size={11} />
                </button>
              </div>
              <b className="kpi-value">{loading ? '—' : value}</b>
              <span className="kpi-label">{label}</span>
              <span className="kpi-hint">{hint}</span>
            </div>
          );
        })}
      </div>

      
    </div>
  );
}